import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ItemSummaryItemSummaryService} from '../shared/asset/item-summary-item-summary.service';
import {ItemSummaryAssetSummaryService} from '../shared/asset/item-summary-asset-summary.service';
import {Asset, AssetInfo, AssetSaleInfo} from '../shared/domain/item';
import {Opportunity} from '../shared/domain/opportunity';
import {AuctionEvent} from '../shared/domain/auction-event';
import {ItemSummaryItemService} from '../shared/asset/item-summary-item.service';
import {ItemSummaryAssetService} from '../shared/asset/item-summary-asset.service';
import {ItemViewType} from '../shared/item-view-type.enum';
import {AssetPackageDto} from '../shared/domain/asset-package';
import {ItemSummaryPageService} from '../shared/asset/item-summary-page.service';

@Component({
  selector: 'lib-item-summary-asset-pps-summary',
  templateUrl: './asset-pps-summary.component.html',
  styleUrls: ['./asset-pps-summary.component.scss'],
  providers: [
    {provide : ItemSummaryItemSummaryService , useClass: ItemSummaryAssetSummaryService},
    {provide: ItemSummaryItemService, useClass: ItemSummaryAssetService}
  ]
})
export class AssetPPSSummaryComponent implements OnInit {

  @Input() itemId: number;
  @Input() fromView: ItemViewType;
  @Input() canAccess: boolean;
  @Output() editModeChanged = new EventEmitter<boolean>();
  asset: Asset;
  assetInfo: AssetInfo;
  assetSaleInfo: AssetSaleInfo;
  assetPackage: AssetPackageDto;
  opportunity: Opportunity;
  auctionEvent: AuctionEvent;
  isAuctionEventActive: boolean;
  isEventEndedMoreThan30DaysAgo: boolean;
  isEventEndedMoreThan120DaysAgo: boolean;

  constructor(public itemSummaryService: ItemSummaryItemSummaryService,
              public itemService: ItemSummaryItemService,
              private itemSummaryPageService: ItemSummaryPageService) {
  }

  ngOnInit() {
  }

  onAssetLoaded(asset: Asset) {
    this.asset = asset;
    this.itemSummaryPageService.loadAssetInformation(this.asset);
  }

  onAssetInfoLoaded(assetInfo: AssetInfo) {
    this.assetInfo = assetInfo;
    this.itemSummaryPageService.loadAssetInfoInformation(this.assetInfo);
  }

  onAssetSaleInfoLoaded(assetSaleInfo: AssetSaleInfo) {
    this.assetSaleInfo = assetSaleInfo;
  }

  onAssetPackageLoaded(assetPackage: AssetPackageDto): void {
    this.assetPackage = assetPackage;
  }

  onOpportunityLoaded(opportunity: Opportunity) {
    this.opportunity = opportunity;
  }

  onAuctionEventLoaded(auctionEvent: AuctionEvent) {
    this.auctionEvent = auctionEvent;
    this.isAuctionEventActive = auctionEvent.activeAuction;
    this.isEventEndedMoreThan30DaysAgo = auctionEvent.eventEndedMoreThan30DaysAgo;
    this.isEventEndedMoreThan120DaysAgo = auctionEvent.eventEndedMoreThan120DaysAgo;
    this.itemSummaryPageService.loadAuctionEventInformation(this.auctionEvent);
  }

  onEditModeChanged(isOnEditMode: boolean) {
    this.editModeChanged.emit(isOnEditMode);
  }

}
